import { instanceEmployee } from '../../../../services/instances';
import type { ResponseAllTreeData, TKResponse } from '../types/services';

export const getOrgPathTree = async (): Promise<ResponseAllTreeData> => {
    const response = await instanceEmployee.get<TKResponse<ResponseAllTreeData>>('/orgpath/tree');
    return response.data.data;
};
